// removed by extract-text-webpack-plugin
module.exports = {"page_pay":"app__css__app-pages-SelfHelp-pay-__index__page_pay"};


//////////////////
// WEBPACK FOOTER
// ./app/pages/SelfHelp/pay/index.css
// module id = 656
// module chunks = 0